import './Footer.css';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-column footer-brand">
          <h3 className="brand-text">PC Build Guru</h3>
          <p>Performance. Precision. Perfection.</p>
        </div>

        <div className="footer-column footer-links">
          <h4>Explore</h4>
          <a href="/">Home</a>
          <a href="/questionnaire">Build</a>
          <a href="/guide">Guides</a>
          <a href="/about">About</a>
        </div>

        <div className="footer-column footer-social">
          <h4>Connect</h4>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13c-3 2-7 2-7 2 9 5 20 0 20-11.5A4.5 4.5 0 0 0 23 3z"/></svg>
            Twitter
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            Instagram
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {currentYear} PC Build Guru. All Rights Reserved.</p>
      </div>
    </footer>
  );
};
